import React, { useState, useEffect } from 'react';
import { useQuery } from 'react-query';
import { Grid, Alert, CircularProgress as MUICircularProgress } from '@mui/material';
import { RequestCashValueLetter } from '../../api/cashvalrequest';
import ReCAPTCHA from 'react-google-recaptcha';
import '../../CorpSite.css';

export default function RequestCVL() {
    const [showButton, setShowButton] = useState(false); //Set to false when ready to deploy
    const [policy, setPolicy] = useState(null);

    const capChange = (v) => { setShowButton(true); }

    const cvCheck = useQuery(['requestCVCheck', policy], RequestCashValueLetter({ PolicyID: policy, Source: 1 }), {
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
        enabled: false,
        cacheTime: 1,
        refetchOnMount: false
    });

    const checkPolicy = () => {
        if (policy !== null) {            
            cvCheck.refetch();
        }
    }

    return (
        <Grid container spacing={2}>
            <Grid item xs={6} className="CorporateLabel">
                Please enter your policy number:
            </Grid>
            <Grid item xs={6}>
                <input type="text" onChange={(e) => setPolicy(e.target.value)} className="CorporateTextbox" />
            </Grid>
            <Grid item xs={6}></Grid>
            <Grid item xs={6}>
                <ReCAPTCHA sitekey="6LfOVCIUAAAAAD-YZDuRxt-arwgCfCA6ymyPKUXW" onChange={capChange} />
            </Grid>            
            {cvCheck.isFetching && <><Grid item xs={6}></Grid><Grid item xs={6}><MUICircularProgress /></Grid></>}
            {!cvCheck.isFetching && <>
                {
                    showButton && <>
                        <Grid item xs={6}></Grid>
                        <Grid item xs={6}>
                            <button type="button" className="CorporateButton" onClick={() => { checkPolicy() }}>Submit</button>
                        </Grid>
                    </>
                }
                <Grid item xs={6}></Grid>
                <Grid item xs={6}>
                    {cvCheck.data?.errorCode &&
                        <Alert severity="error">
                        {cvCheck.data?.errorCode === 'NotActive' && <>The entered policy is either terminated or could not be located.  Please call customer service for more information at 800-628-5433.</>}
                        {cvCheck.data?.errorCode === '90DayRule' && <>A cash value request was received within the last 90 days and we are unable to process another transaction.  If you would like to make another request, please call customer service at 800-628-5433.</>}
                        {cvCheck.data?.errorCode === 'SYSTEM' && <>A system error has occurred.  Please try again later.</>}
                        </Alert>
                    }
                    {cvCheck.data?.canRequest &&
                        <Alert severity="success">Your Cash Value letter will be mailed to the Owner's address on record and may take 5-10 business days to receive.</Alert>
                    }
                </Grid>
            </>
            }
        </Grid>)
}